export default "__VITE_ASSET__CIe5vbA5__"